@import '~style-sheet-helpers/core.less';
@import (reference) '../../constants/spacing.module.less';
@import (reference) '../../constants/z-index.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.notification-hub-wrapper {
  position: absolute;
  right: 104px;
  top: 44px;
  height: calc(100% - 72px);
  width: 480px;
  background-color: var(--grey-100);
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  --shadow-notification-hub: 0 4px 16px rgba(0, 0, 0, 0.12);
  box-shadow: var(--shadow-notification-hub);
  z-index: @z-notification-hub;
  display: flex;
  flex-direction: column;
  max-height: 1024px;

  @media (max-width: 768px) {
    right: 0;
    height: calc(100% - 44px);
    width: 100%;
    max-height: none;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-16;
  gap: @space-12;
  background-color: var(--white);
  border-radius: 8px 8px 0 0;
}

.header-title {
  align-items: center;
}

.header-label {
  font-size: 16px;
  font-weight: 500;
  color: var(--grey-900);
}

.header-actions {
  align-items: center;
}

.toggle-hub {
  cursor: pointer;
  color: var(--grey-600);
  align-items: center;
  justify-content: center;
  padding: @space-4;

  > svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: var(--grey-900);
  }
}
